function buildAppUrl(baseUrl: string, pathname: string): string {
  const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
  return new URL(pathname, normalizedBaseUrl).toString();
}

export function buildApplicationReviewUrl({
  applicationId,
  baseUrl,
  jobId,
}: {
  applicationId: string;
  baseUrl: string;
  jobId: string;
}): string {
  return buildAppUrl(
    baseUrl,
    `/jobs/${encodeURIComponent(jobId)}/applications/${encodeURIComponent(applicationId)}`
  );
}

export function buildCandidateApplicationUrl({
  applicationId,
  baseUrl,
}: {
  applicationId: string;
  baseUrl: string;
}): string {
  return buildAppUrl(
    baseUrl,
    `/applications/${encodeURIComponent(applicationId)}`
  );
}

export function buildConversationUrl({
  baseUrl,
  conversationId,
}: {
  baseUrl: string;
  conversationId: string;
}): string {
  return buildAppUrl(
    baseUrl,
    `/conversations/${encodeURIComponent(conversationId)}`
  );
}

export function buildConversationsUrl(baseUrl: string): string {
  return buildAppUrl(baseUrl, "/conversations");
}

export function buildJobListingsUrl(baseUrl: string): string {
  return buildAppUrl(baseUrl, "/job-listings");
}

export function buildJobListingUrl({
  baseUrl,
  slug,
}: {
  baseUrl: string;
  slug: string;
}): string {
  return buildAppUrl(baseUrl, `/job-listings/${encodeURIComponent(slug)}`);
}

export function buildJobsUrl(baseUrl: string): string {
  return buildAppUrl(baseUrl, "/jobs");
}

export function buildManageJobUrl({
  baseUrl,
  jobId,
}: {
  baseUrl: string;
  jobId: string;
}): string {
  return buildAppUrl(baseUrl, `/jobs/${encodeURIComponent(jobId)}`);
}

export function buildOnboardingUrl(baseUrl: string): string {
  return buildAppUrl(baseUrl, "/onboarding");
}

export function buildOrganizationInviteUrl({
  baseUrl,
  inviteCode,
}: {
  baseUrl: string;
  inviteCode: string;
}): string {
  return buildAppUrl(
    baseUrl,
    `/organizations/invite/${encodeURIComponent(inviteCode)}`
  );
}
